export default "__VITE_ASSET__CyJ_b7KR__"